<template>
  <div class="box">
    <div class="main">
      <van-cell-group>
        <van-cell title="身份证号：" value="211211199101010011" />
        <van-cell title="就诊卡号：" value="12341234" />
      </van-cell-group>
    </div>
    <div class="footer">
      <van-button
        type="info"
        :round="true"
        size="normal"
        style="margin-left:10px"
        @click="go"
        >添加就诊人</van-button
      >
    </div>
  </div>
</template>

<script>
export default {
  name: 'addPatient',
  data() {
    return {}
  },
  created() {},
  mounted() {},
  methods: {
    onClickLeft() {},
    go() {
      this.$router.push('goPrevention')
    }
  }
}
</script>
<style scoped>
.van-cell /deep/ .van-cell__title {
  -webkit-box-flex: 0.25;
  -webkit-flex: 0.25;
  flex: 0.25;
  color: #969799;
}
.van-cell /deep/ .van-cell__value {
  -webkit-box-flex: 0.5;
  -webkit-flex: 0.5;
  flex: 0.5;
  color: #323233;
  text-align: left;
}
.footer {
  width: 100vw;
  position: fixed;
  bottom: 0px;
  left: 0px;
  right: 0px;
  display: flex;
  background-color: #ffffff;
}
.footer button {
  width: calc(100% - 40px);
  margin: 10px 20px 10px 20px;
  font-size: 18px;
}
</style>
